module.exports = __webpack_public_path__ + "img/round9.28c4361b.png";